import { Injectable } from '@angular/core';

// Env
import { environment } from '@environment';
import { Theme } from '../types/theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  // Private
  public theme: Theme = Theme.default();

  /**
   * Constructor
   */

  constructor() {
    this.setupTheme();
  }

  /**
   * Methods
   */


  setupTheme(): void {
    switch (environment.theme) {
      case 'cinedeck':
        this.theme = Theme.cinedeck();
        break;
    
      case 'roadrunner':
      case 'default':
      default:
        this.theme = Theme.default();
        break;
    }

    const root = document.documentElement;
    root.style.setProperty('--background-primary', this.theme.styles.background);
    root.style.setProperty('--action-color', this.theme.styles.actionColor);
    root.style.setProperty('--button-primary-color', this.theme.styles.buttons.primary);
    root.style.setProperty('--button-primary-hover-color', this.theme.styles.buttons.primaryHover);
    root.style.setProperty('--button-primary-text-color', this.theme.styles.buttons.primaryText);
    root.style.setProperty('--button-secondary-color', this.theme.styles.buttons.secondary);
    root.style.setProperty('--button-secondary-hover-color', this.theme.styles.buttons.secondaryHover);
    root.style.setProperty('--button-secondary-text-color', this.theme.styles.buttons.secondaryText);

    this.updateFavicon();
  }

  updateFavicon(): void {
    const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = this.theme.favicon;
    document.getElementsByTagName('head')[0].appendChild(link);

    document.title = this.theme.product;
  }

}
